import styled, { css } from 'styled-components';

import { media } from '@theme/media';
import { COLORS } from '@theme/colors';

import { CONTAINER_PADDING, CONTAINER_WIDTH } from './blocks.constants';

export const containerStyles = css`
  max-width: ${CONTAINER_WIDTH}px;
  width: 100%;
  margin: 0 auto;
  padding: 0 ${CONTAINER_PADDING}px;
`;

export const linkStyles = css`
  border-bottom: 1px solid ${COLORS.BLACK};
`;

export const paragraphTextStyles = css`
  font-size: 18px;
  line-height: 1.4em;

  ${media.mobile} {
    font-size: 20px;
    line-height: 1.25em;
    font-weight: 500;
    letter-spacing: normal;
  }

  ${media.tablet} {
    line-height: 1.4em;
  }

  a {
    ${linkStyles};
  }
`;

export const paragraphStyles = css`
  margin: 0 0 1.4em;

  ${paragraphTextStyles};
`;

export const colonSuffix = css`
  span:first-child::after {
    content: ':';
  }
`;

export const masterBlockBottomLine = css`
  &::after {
    content: '';
    display: block;
    width: calc(100% - ${CONTAINER_PADDING}px * 2);
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    margin: 0 ${CONTAINER_PADDING}px;
  }
`;

export const legalPageFontStyles = css`
  font-size: 14px;
  line-height: 1.4em;

  ${media.mobile} {
    font-size: 13px;
    line-height: 1.4em;
    letter-spacing: 0.02em;
  }
`;

export const Title = styled.div`
  ${legalPageFontStyles};
  display: block;
  font-weight: 500;
  text-transform: uppercase;
  text-align: center;
  padding-top: 9px;
  padding-bottom: 6px;
  border-bottom: 1px solid ${COLORS.BLACK};
  margin-bottom: 34px;
  margin-top: 80px;

  ${media.tablet} {
    margin-top: 60px;
  }
`;
